<template>
  <listTemplate :classCustom="'list-job'">
    <template #header>
      <mainHeader>
        <template #filterByStatus>
          <div class="leftSection">
            <div
              class="header-title wrapper-content__main font-size__large font-weight__bold"
            >
              <h3 class="font-weight__bold">
                Báo cáo tình hình xử lý văn bản đến của các đơn vị trong TCT
              </h3>
            </div>
          </div>
        </template>
      </mainHeader>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <el-form
                  ref="form"
                  :model="form"
                  :rules="validationRules"
                  label-position="top"
                  class="input-no__label"
                >
                  <el-row :gutter="24" class="leftSection margin-right-10">
                    <el-col
                      :span="10"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span
                        class="label-input width__auto"
                      >Ngày văn bản chuyển đến</span>

                      <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="dateRangeChanged"
                      ></el-date-picker>
                    </el-col>

                    <el-col
                      :span="6"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto">Đơn vị</span>
                      <el-select
                        v-model="form.deptIds"
                        class="style-fullWidth input-none__border has-border__bottom"
                        size="medium"
                        multiple
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in departments"
                          :key="item.id"
                          :label="item.deptName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col
                      :span="6"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <span class="label-input width__auto">Mức độ xử lý</span>
                      <el-select
                        v-model="form.processLevelIds"
                        class="style-fullWidth input-none__border has-border__bottom"
                        size="medium"
                        multiple
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in processes"
                          :key="item.id"
                          :label="item.categoryName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col
                      :span="2"
                      class="flex-row flex-left__top custom-label__input"
                    >
                      <el-button
                        class="btnSolid__blue"
                        size="medium"
                        @click="exportReport"
                      >
                        <i class="fas fa-mouse-pointer"></i>
                        &nbsp;Xuất báo cáo
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
            </subHeader>
          </template>
        </listTemplate>
      </div>
    </template>
  </listTemplate>
</template>

<script>

  import SubHeader from "../../../components/main/sub-header";
  import MainHeader from "../../../components/header/main-header";
  import ListTemplate from "../../common/list";
  import FilterReport from "../filterReport";
  import utils from "../../../services/utils";
  import VueCookies from "vue-cookies";
  import constants from "../../../constants";
  import departmentService from "../../../services/departmentService";
  import h from "../../../services/h";
  import dateUtils from "../../../dateUtils";
  import categoryViewService from "../../../services/categoryViewService";

  export default {
    name: "bao-cao-tinh-hinh-xl-vb-theo-don-vi",
    components: {
      SubHeader,
      MainHeader,
      ListTemplate,
      FilterReport,
    },

    data: () => {
      return {
        form: {
          fromDate: null,
          toDate: null,
          deptIds: [],
          processLevelIds: []
        },
        REPORT: constants.REPORT,
        departments: null,
        departments_: null,
        processes: null,
        processes_: null,
        processLevelCode: constants.CATEGORY_GROUP_CODE.PROCESS_LEVEL,
        dateRange: null,
        validationRules: {},
        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      }
    },

    computed: {
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },

      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
    },

    created() {
      if (!this.userDeptRole) return;
      this.loadDepartments();
      this.loadProcessLevel();
      this.initValidationRules();
      this.initForm();
    },

    methods: {

      initForm() {
        this.form = {
          fromDate: this.$route.query.fromDate
            ? parseInt(this.$route.query.fromDate)
            : undefined,
          toDate: this.$route.query.toDate
            ? parseInt(this.$route.query.toDate)
            : undefined,
          deptIds: this.$route.query.deptIds || undefined,
          processLevelIds: this.$route.query.processLevelIds || undefined
        };
        this.initDateRange();
      },


      dateRangeChanged() {
        this.form.fromDate =
          this.dateRange && this.dateRange[0]
            ? this.dateRange[0].getTime()
            : undefined;
        this.form.toDate =
          this.dateRange && this.dateRange[1]
            ? this.dateRange[1].getTime()
            : undefined;
      },

      initDateRange() {
        if (this.form.fromDate || this.form.toDate) {
          this.dateRange = [
            dateUtils.toMoment(this.form.fromDate),
            dateUtils.toMoment(this.form.toDate)
          ];
        } else {
          this.dateRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
          );
          let defaultTimeRange = dateUtils.getTimesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
          );
          this.form.fromDate = defaultTimeRange[0];
          this.form.toDate = defaultTimeRange[1];
        }
      },

      loadDepartments() {
        return departmentService
          .findAll()
          .then(response => {
            this.departments_ = response.data;
            this.departments = [];
            this.departments.push(
              ...h.collect(this.departments_, item => {
                return {id: item.id, deptName: item.deptName};
              })
            );
          });
      },

      loadProcessLevel() {
        categoryViewService
          .findAll(
            {groupCode: this.processLevelCode},
            {sort: "order,asc", page: 0, size: 1000}
          )
          .then(response => {
            this.processes_ = response.data;
            this.processes = [];
            this.processes.push(
              ...h.collect(this.processes_, item => {
                return {id: item.id, categoryName: item.categoryName}
              })
            )
          });
      },

      buildQuery() {
        return {
          fromDate: this.form.fromDate || undefined,
          toDate: this.form.toDate || undefined,
          userDeptRoleId: this.userDeptRoleId,
          deptIds: this.form.deptIds,
          processLevelIds: this.form.processLevelIds
        };
      },

      exportReport() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message({message: "Có lỗi nhập liệu", type: "error"});
            return;
          }
          if (!this.validate()) return;

          let query = this.buildQuery();

          let routerQuery = utils.merge(this.$router.query, {
            fromDate: query.fromDate,
            toDate: query.toDate,
            deptIds: query.deptIds,
            processLevelIds: query.processLevelIds,
            tenantCode : VueCookies.get(constants.HTTP_HEADER_KEY.X_TENANT_CODE),

          });

          this.$router.replace({
            name: "tinhHinhXuLyVanBanDenTheoDonVi",
            params: this.$router.params,
            query: routerQuery
          });

          let baseServiceURL = constants.BASE_SERVICE_URL;
          let reportUrl = constants.REPORT.VB_DOC.URL.BAOCAOTINHHINHXLVBDENTHEODONVI;
          console.log(`${baseServiceURL}${reportUrl}?${utils.serialize(query)}`);
          window.open(
            `${baseServiceURL}${reportUrl}?${utils.serialize(query)}`,
            "_blank "
          );
        });
      },

      validate() {
        return new Promise(resolve => {
          let diff;
          if (!this.form.fromDate || !this.form.toDate) {
            this.$message({
              message: "Khoảng thời gian (từ ngày/đến ngày) bắt buộc nhập",
              type: "error"
            });
            return;
          }
          let fromDate = dateUtils.toMoment(this.form.fromDate);
          let toDate = dateUtils.toMoment(this.form.toDate);
          diff = toDate.diff(fromDate, "day");
          if (diff < 0) {
            this.$message({
              message: "Trường Đến ngày không được nhỏ hơn trường tới ngày",
              type: "error"
            });
            return;
          }
          if (diff > 365) {
            this.$message({
              message: "Khoảng thời gian phải nhỏ hơn 1 năm",
              type: "error"
            });
            return;
          }
          resolve();
        });
      },

      initValidationRules() {
        let requiredRule = {
          required: true,
          message: "Trường dữ liệu bắt buộc",
          trigger: "change"
        };
        this.validationRules = {
          fromDate: [requiredRule],
          toDate: [requiredRule],
        };
      },

    }
  }
</script>

<style scoped>
.listReport {
  margin: 12px 12px 0 0;
}

.scroll-area {
  max-height: calc(100vh - 130px);
}
</style>



// WEBPACK FOOTER //
// src/views/report/incomingDoc/bao-cao-tinh-hinh-xl-vb-theo-don-vi.vue